import { Button } from '@consta/uikit/Button'
import { withTooltip } from '@consta/uikit/withTooltip'
import { getSimpleTooltipContent } from '@library/utils'
import cn from 'classnames'
import type { FC } from 'react'

import type { ProjectObjectType } from '../../types'
import css from './ToolbarItem.css'

const ButtonWithTooltip = withTooltip({
  direction: 'rightStartUp',
  appearTimeout: 300,
  offset: 10,
})(Button)

type ToolbarItemProps = {
  item: ProjectObjectType
  selectedItem: ProjectObjectType
  setSelectedItem: (arg: ProjectObjectType) => void
}

export const ToolbarItem: FC<ToolbarItemProps> = ({ item, selectedItem, setSelectedItem }) => {
  const onItemClick = () => {
    item.onClick()
    setSelectedItem(item)
  }

  const itemClassName = cn({
    [css.button]: true,
    [css.selected]: selectedItem.text === item.text,
  })

  return (
    <ButtonWithTooltip
      className={itemClassName}
      size="s"
      view="clear"
      onlyIcon={true}
      iconLeft={item.icon}
      tooltipProps={{
        tooltipContent: getSimpleTooltipContent(item.text),
      }}
      onClick={onItemClick}
    />
  )
}
